import { useAuth0 } from '@auth0/auth0-react';
import ErrorIcon from '@mui/icons-material/Error';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputLabel,
    LinearProgress,
    linearProgressClasses,
    MenuItem,
    Select,
    TextField,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import { addYears, endOfMonth, getYear, isBefore, parse } from 'date-fns';
import React, { useState } from 'react';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    margin: '8px',
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.primary.light,
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.primary.main,
    },
}));

const TypographyError = styled(Typography)(({ theme }) => ({
    color: theme.palette.error.main,
}));

const InputNone = styled('input')(({ theme }) => ({
    display: 'none',
}));

const LicenceInformation = props => {
    const [state, setState] = useState({
        licenceExpiry: {
            monthValue: '01',
            yearValue: getYear(Date.now()),
            error: false,
        },
        licenceNumber: { value: '', error: false },
        state: { value: 'VIC' },
        ext: { value: '', error: false },
        file: { value: '', error: false },
    });
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState({ loaded: 0, total: 0 });
    const [document, setDocument] = useState({});
    const [isSelected, setIsSelected] = useState(false);

    const { getAccessTokenSilently } = useAuth0();

    const handleLicenceNumber = e => {
        let licence = state.licenceNumber;
        licence.value = e.target.value;
        setState({
            ...state,
            licenceNumber: licence,
        });
    };

    const handleExt = e => {
        let licence = state.ext;
        licence.value = e.target.value;
        setState({
            ...state,
            ext: licence,
        });
    };

    const handleMonthChange = e => {
        let tempLicence = state.licenceExpiry;
        tempLicence.monthValue = e.target.value;
        setState({
            ...state,
            licenceExpiry: tempLicence,
        });
    };

    const handleYearChange = e => {
        let tempLicence = state.licenceExpiry;
        tempLicence.yearValue = e.target.value;
        setState({
            ...state,
            licenceExpiry: tempLicence,
        });
    };

    const handleStateChange = e => {
        console.log(JSON.stringify(e.target));
        setState({
            ...state,
            state: { value: e.target.value },
        });
    };

    const verifyLicenceNumber = () => {
        let licenceNumber = state.licenceNumber;
        let error = false;
        if (licenceNumber.value.length < props.stringLength) {
            licenceNumber.error = true;
            licenceNumber.errorCode = `Please enter a valid ${props.name} number`;
            error = true;
        } else {
            licenceNumber.error = false;
            licenceNumber.errorCode = '';
        }
        setState({
            ...state,
            licenceNumber: licenceNumber,
        });
        return error;
    };

    const verifyDate = () => {
        let licenceExpiry = state.licenceExpiry;
        let error = false;
        let licenceDate = state.licenceExpiry.monthValue;
        let newLicenceDate = licenceDate.concat(
            '/',
            state.licenceExpiry.yearValue
        );
        console.log(newLicenceDate);
        console.log(parse(newLicenceDate, 'MM/yyyy', new Date()));
        console.log(endOfMonth(parse(newLicenceDate, 'MM/yyyy', new Date())));
        console.log(
            isBefore(
                endOfMonth(parse(newLicenceDate, 'MM/yyyy', new Date())),
                Date.now()
            )
        );
        if (
            isBefore(
                endOfMonth(parse(newLicenceDate, 'MM/yyyy', new Date())),
                Date.now()
            )
        ) {
            licenceExpiry.error = true;
            licenceExpiry.errorCode = 'Please enter a valid licence';
            error = true;
        } else {
            licenceExpiry.error = false;
            licenceExpiry.errorCode = '';
        }
        setState({
            ...state,
            licenceExpiry: licenceExpiry,
        });
        return error;
    };

    const verifyExt = () => {
        let ext = state.ext;
        let error = false;
        if (props.ext) {
            if (ext.value === '') {
                ext.error = true;
                ext.errorCode = 'Please enter a number';
                error = true;
            } else {
                ext.error = false;
                ext.errorCode = '';
            }
            setState({
                ...state,
                ext: ext,
            });
        }
        return error;
    };

    const verifyFile = () => {
        let file = state.file;
        let error = false;
        if (typeof document.name === 'undefined') {
            file.error = true;
            file.errorCode = 'Please upload an image for evidence';
            error = true;
        } else {
            file.error = false;
            file.errorCode = '';
        }
        setState({
            ...state,
            file: file,
        });
        return error;
    };

    async function verifyLicence() {
        let error = false;
        error = verifyExt();
        if (error === false) {
            error = verifyDate();
        }
        if (error === false) {
            error = verifyLicenceNumber();
        }
        if (error === false) {
            error = verifyFile();
        }
        return error;
    }

    const fileSelectHandler = event => {
        console.log(event.target.files[0]);
        if (event.target.files[0]) {
            setIsSelected(true);
            setDocument(event.target.files[0]);
            setState({
                ...state,
                file: { error: false, errorCode: '' },
            });
        } else {
            setIsSelected(false);
        }
    };

    const handleNextButton = async e => {
        const verification = await verifyLicence();
        if (verification === false) {
            setLoading(true);
            //submitLicence
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            let data = {};
            if (props.ext) {
                data = {
                    number: { value: state.licenceNumber.value },
                    expiry: {
                        monthValue: state.licenceExpiry.monthValue,
                        yearValue: state.licenceExpiry.yearValue,
                    },
                    ext: { value: state.ext.value },
                };
            } else {
                data = {
                    number: { value: state.licenceNumber.value },
                    expiry: {
                        monthValue: state.licenceExpiry.monthValue,
                        yearValue: state.licenceExpiry.yearValue,
                    },
                    state: { value: state.state.value },
                };
            }

            const params = {
                filename: document.name,
                type: props.type,
                permission: 87,
                data: data,
                size: document.size,
            };
            setProgress({
                loaded: 0,
                total: 100,
            });
            const permission = await axios
                .post('/uploadDocumentPermissionsAdvanced', params, {
                    baseURL: process.env.REACT_APP_API_GATEWAY,
                    timeout: 15000,
                    headers: {
                        authorization: `Bearer ${token}`,
                        'Content-Type': document.type,
                    },
                })
                .catch(err => {
                    setLoading(false);
                    console.log('error', err);
                    setState({
                        ...state,
                        mainError: `Failed to upload File. Error: ${err.response.data.error}`,
                    });
                });
            const headers = {
                'Content-Type': document.type,
            };
            console.log(JSON.stringify(permission));
            await axios
                .put(permission.data.uploadURL, document, {
                    timeout: 15000,
                    headers: headers,
                    onUploadProgress: function (progressEvent) {
                        setProgress({
                            loaded: progressEvent.loaded,
                            total: progressEvent.total,
                        });
                    },
                })
                .then(() => {
                    setLoading(false);
                    props.clickNextButton();
                })
                .catch(err => {
                    setLoading(false);
                    console.log('error', err);
                    setState({
                        ...state,
                        mainError: `Failed to upload ${props.name} information`,
                    });
                });
            // await axios
            //     .post(
            //         '/uploadUserDocument',
            //         { data: data, type: props.type },
            //         {
            //             baseURL: process.env.REACT_APP_API_GATEWAY,
            //             url: '/uploadUserDocument',
            //             timeout: 30000,
            //             headers: {
            //                 authorization: `Bearer ${token}`,
            //                 'Content-Type': 'application/json',
            //             },
            //         }
            //     )
            //     .then(() => {
            //         setLoading(false);
            //         props.clickNextButton(e);
            //     })
            //     .catch(err => {
            //         setLoading(false);
            //         console.log('error', err);
            //         setState({
            //             ...state,
            //             mainError: `Failed to upload ${props.name} information`,
            //         });
            //     });
        }
    };

    return (
        <div>
            <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ margin: '10px' }}
            >
                {props.title}
            </Typography>
            {props.type === 'teacherId' && (
                <Typography
                    variant="body1"
                    sx={{
                        margin: '10px',
                        fontStyle: 'italic',
                        whiteSpace: 'pre-line',
                    }}
                >
                    {`Please enter most recent licence.
                    Other Licences can be added later
                    in the upload documents section.`}
                </Typography>
            )}
            <Box>
                <InputNone
                    type="file"
                    id="licence-file"
                    onChange={fileSelectHandler}
                    data-cy="licence-file"
                />
                <label htmlFor="licence-file">
                    <Button
                        color="secondary"
                        variant="contained"
                        component="span"
                        sx={{ marginLeft: '10px' }}
                    >
                        Choose file
                    </Button>
                </label>
            </Box>

            {typeof document.name !== 'undefined' && (
                <Typography sx={{ marginLeft: '10px' }}>
                    {document.name}
                    <TaskAltIcon sx={{ marginLeft: '8px' }} color="success" />
                </Typography>
            )}

            {state.file.error === true && (
                <Box sx={{ marginLeft: '10px' }}>
                    <Typography color="error" variant="body">
                        {state.file.errorCode}
                    </Typography>
                </Box>
            )}
            <TextField
                id="licenceNumber"
                data-cy="licence-number"
                label={`${props.name} number`}
                variant="outlined"
                value={state.licenceNumber.value}
                onChange={handleLicenceNumber}
                sx={{ margin: '10px' }}
                error={state.licenceNumber.error}
                helperText={state.licenceNumber.errorCode}
                onBlur={() => verifyLicenceNumber()}
            />
            {props.ext && (
                <TextField
                    id="ext"
                    label="User Number"
                    data-cy="user-number"
                    variant="outlined"
                    value={state.ext.value}
                    onChange={handleExt}
                    sx={{ margin: '10px' }}
                    error={state.ext.error}
                    helperText={state.ext.errorCode}
                    onBlur={() => verifyExt()}
                />
            )}
            <Box
                sx={{
                    borderRadius: '5px',
                    border: '1px solid lightgrey',
                    width: '200px',
                    marginLeft: 1,
                    paddingTop: '15px',
                }}
            >
                <Typography
                    sx={{
                        marginLeft: '15px',
                        marginTop: '-26px',
                        position: 'absolute',
                        paddingLeft: '2px',
                        paddingRight: '2px',
                        'background-color': 'white',
                        fontSize: '0.75em',
                    }}
                >
                    Expiry
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        '& > :not(style)': { m: 1 },
                    }}
                >
                    <FormControl
                        sx={{ margin: '10px', minWidth: '65px' }}
                        error={state.licenceExpiry.error}
                    >
                        <InputLabel id="demo-simple-select-label">
                            Month
                        </InputLabel>
                        <Select
                            labelId="ExpiryYear"
                            id="demo-simple-select"
                            value={state.licenceExpiry.monthValue}
                            label="monthValue"
                            onChange={handleMonthChange}
                        >
                            {[
                                '01',
                                '02',
                                '03',
                                '04',
                                '05',
                                '06',
                                '07',
                                '08',
                                '09',
                                '10',
                                '11',
                                '12',
                            ].map(i => (
                                <MenuItem value={i} key={i}>
                                    {i}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl
                        sx={{ margin: '10px', minWidth: '90px' }}
                        error={state.licenceExpiry.error}
                        onBlur={() => verifyDate()}
                    >
                        <InputLabel id="demo-simple-select-label">
                            Year
                        </InputLabel>
                        <Select
                            labelId="ExpiryYear"
                            id="demo-simple-select"
                            value={state.licenceExpiry.yearValue}
                            label="yearValue"
                            onChange={handleYearChange}
                            data-cy="expiry-year"
                        >
                            {[
                                getYear(Date.now()),
                                getYear(addYears(Date.now(), 1)),
                                getYear(addYears(Date.now(), 2)),
                                getYear(addYears(Date.now(), 3)),
                                getYear(addYears(Date.now(), 4)),
                                getYear(addYears(Date.now(), 5)),
                                getYear(addYears(Date.now(), 6)),
                                getYear(addYears(Date.now(), 7)),
                                getYear(addYears(Date.now(), 8)),
                                getYear(addYears(Date.now(), 9)),
                                getYear(addYears(Date.now(), 10)),
                                getYear(addYears(Date.now(), 11)),
                                getYear(addYears(Date.now(), 12)),
                                getYear(addYears(Date.now(), 13)),
                                getYear(addYears(Date.now(), 14)),
                                getYear(addYears(Date.now(), 15)),
                            ].map(i => (
                                <MenuItem
                                    value={i}
                                    key={i}
                                    data-cy="expiry-option"
                                >
                                    {i}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                {state.licenceExpiry.error && (
                    <Typography
                        color="error"
                        sx={{
                            fontWeight: '500',
                            fontSize: '14px',
                            textAlign: 'center',
                        }}
                    >
                        {state.licenceExpiry.errorCode}
                    </Typography>
                )}
            </Box>

            {/* value={`${state.licenceExpiry.monthValue} \/ ${state.licenceExpiry.yearValue}`} */}
            {!props.ext && (
                <FormControl sx={{ margin: '10px', minWidth: '120px' }}>
                    <InputLabel id="demo-simple-select-label">State</InputLabel>
                    <Select
                        labelId="State"
                        id="demo-simple-select"
                        value={state.state.value}
                        label="State"
                        onChange={handleStateChange}
                    >
                        <MenuItem value="VIC">Victoria</MenuItem>
                        <MenuItem value="NSW">New South Wales</MenuItem>
                        <MenuItem value="QLD">Queensland</MenuItem>
                        <MenuItem value="SA">South Australia</MenuItem>
                        <MenuItem value="WA">Western Australia</MenuItem>
                        <MenuItem value="NT">Northern Territory</MenuItem>
                        <MenuItem value="ACT">
                            Australian Capital Territory
                        </MenuItem>
                        <MenuItem value="TAS">Tasmania</MenuItem>
                    </Select>
                </FormControl>
            )}
            <Box
                sx={{
                    margin: '20px',
                    paddingTop: '15px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                {loading && (
                    <BorderLinearProgress color="primary"></BorderLinearProgress>
                )}

                <Button
                    onClick={handleNextButton}
                    disabled={loading}
                    variant="outlined"
                    size="large"
                    data-cy="next-doc"
                >
                    Next
                </Button>
                {props.nextButton && (
                    <Button
                        onClick={() => {
                            props.clickNextButton();
                        }}
                        variant="outlined"
                        size="large"
                        disabled={loading}
                        sx={{ marginLeft: '14px' }}
                        data-cy="skip"
                    >
                        Skip
                    </Button>
                )}
            </Box>
            {typeof state.mainError !== 'undefined' && (
                <TypographyError variant="body">
                    <ErrorIcon />
                    {state.mainError}
                </TypographyError>
            )}
        </div>
    );
};

export default LicenceInformation;
